import BaseService from '@/network/base-service'

class AtestadoService extends BaseService {
  constructor () {
    super(`${process.env.VUE_APP_API_BASE_URL}/paciente/paciente/documentossolicitacoes`)
  }
  solicitarAtestadoCadeiraRodas (params) {
    return this.post(`solicitar/atestado/cadeirarodas`, { ...params })
  }
  solicitarSeloAcessibilidade (params) {
    return this.post(`solicitar/atestado/seloacessibilidade`, { ...params })
  }
  solicitarFraldas (params) {
    return this.post(`solicitar/atestado/fornecimentofraldas`, { ...params })
  }
  solicitarAtestadoInternacoes (params) {
    return this.post(`solicitar/atestado/internacao`, { ...params })
  }
  solicitarAtestadoComparecimento (params) {
    return this.post(`solicitar/atestado/comparecimento`, { ...params })
  }
  solicitarDeclaracaoAtendimentos (params) {
    return this.post(`solicitar/atestado/declaracaoatendimentos`, { ...params })
  }
  getFinalidades (tipo) {
    return this.get(`finalidades/${tipo}`)
  }
  getCombos () {
    return this.get(`combos`)
  }
}

export default new AtestadoService()
